<template>
  <div class="login-footer">
    <div class="main">
      <span>联系地址：上海市闵行区虹梅南路3833号</span>
      <br />
      <span> &copy;Copyright2022 上海佳配汽车零部件有限公司版权所有</span>
      <span>
        <br />
        <a
          target="_blank"
          href="http://www.beian.gov.cn/portal/registerSystemInfo?spm=a21bo.2017.1997523009.44.5af911d91G6eF5&recordcode=31011202008703"
        >
          <img
            src="@/assets/images/home/plice.png"
            alt=""
            style="width: 15px; vertical-align: middle"
          />
          沪公网安备 31011202008703
        </a>
        <a target="_blank" href="https://beian.miit.gov.cn/#/Integrated/index"
          >沪ICP备17051338号-3
        </a>
        <!-- 沪ICP备17051338号-3 &nbsp; -->
        </span
      >
      <!-- <a target="_blank" href="/legalStatement"> 法律声明 </a> -->
      <!-- <a href="javascript:void(0)"> 法律声明 </a> -->
    </div>
    <!-- 联系地址：上海市闵行区虹梅南路3833号 Copyright@2021 上海佳配汽车零部件有限公司版权所有 沪公网安备 11010502040284号 沪ICP备16054851号-2 沪B2-20200811 -->
  </div>
</template>

<script>
export default {
  name: 'login-footer',
  components: {},
  data() {
    return {}
  },
  created() {},
  methods: {},
  computed: {},
  watch: {}
}
</script>
<style lang="less" scoped>
.login-footer {
  // .w {
  //   width: 1200px;
  //   margin: 0 auto;
  // }
  // .main-p {
  //   padding-top: 88px;
  //   padding-bottom: 85px;
  //   line-height: 28px;
  //   text-align: center;
  //   font-size: 16px;
  //   color: #8d8d8d;
  //   letter-spacing: 1.5px;
  //   img {
  //     display: inline-block;
  //     vertical-align: middle;
  //   }
  // }
  height: 170px;
  padding-left: 17px;
  padding-top: 85px;
  // padding-bottom: 25px;
  .main {
    width: 1200px;
    margin: 0 auto;
    text-align: center;
    line-height: 25px;
    span {
      // display: inline-block;
      letter-spacing: 0.5px;
      // padding: 20px 0;
      font-size: 12px;
      margin-top: 5px;
    }
    a {
      color: #515a6e;
      font-size: 12px;
    }
    a:hover {
      color: #e90d0d;
    }
  }
}
</style>
